import React, { useState } from "react";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const createEmptyQuestion = () => ({
  question: "",
  options: ["", ""],
  correctAnswer: "",
  difficulty: "Easy",
  marks: 1,
});

const CreateQuestions = () => {
  const [collegeList, setCollegeList] = useState<any[]>([]);
  const navigate = useNavigate();
  const [collegeId, setCollegeId] = useState("");

  const [questions, setQuestions] = useState([createEmptyQuestion()]);

  const handleChange = (
    qIndex: number,
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;

    setQuestions((prev) =>
      prev.map((q, i) =>
        i === qIndex
          ? {
              ...q,
              [name]: name === "marks" ? Number(value) : value,
            }
          : q
      )
    );
  };

  const handleOptionChange = (
    qIndex: number,
    optIndex: number,
    value: string
  ) => {
    setQuestions((prev: any) =>
      prev.map((q: any, i: any) => {
        if (i !== qIndex) return q;

        const updatedOptions = [...q.options];
        const oldValue = updatedOptions[optIndex];

        updatedOptions[optIndex] = value;

        return {
          ...q,
          options: updatedOptions,
          correctAnswer: q.correctAnswer === oldValue ? value : q.correctAnswer,
        };
      })
    );
  };

  useEffect(() => {
    getCollegeList();
  }, []);

  const getCollegeList = async () => {
    try {
      const data = {
        search: "",
        start: 1,
        count: 10,
        type: "registerNow",
      };
      const res: any = await AdminService.allCollege(data);

      if (res.status === "Success") {
        setCollegeList(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const addQuestion = () => {
    setQuestions((prev) => [...prev, createEmptyQuestion()]);
  };

  const removeQuestion = (index: number) => {
    setQuestions((prev) => prev.filter((_, i) => i !== index));
  };

  const addOption = (qIndex: number) => {
    setQuestions((prev) =>
      prev.map((q, i) =>
        i === qIndex
          ? {
              ...q,
              options: [...q.options, ""],
            }
          : q
      )
    );
  };

  const removeOption = (qIndex: number, optIndex: number) => {
    setQuestions((prev) =>
      prev.map((q, i) => {
        if (i !== qIndex) return q;

        if (q.options.length <= 2) {
          toast.error("Minimum 2 options required");
          return q;
        }

        const updatedOptions = q.options.filter(
          (_, index) => index !== optIndex
        );

        let updatedCorrectAnswer: any = q.correctAnswer;

        if (updatedCorrectAnswer >= updatedOptions.length) {
          updatedCorrectAnswer = 0;
        }

        return {
          ...q,
          options: updatedOptions,
          correctAnswer: updatedCorrectAnswer,
        };
      })
    );
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!collegeId) {
      toast.error("Please select a college");
      return;
    }

    const payload = questions.map((question) => ({
      ...question,
      collegeId,
    }));

    try {
      await AdminService.createQuestions({
        questions: payload,
      });

      toast.success("Questions created successfully");
      navigate("/exam/questions");
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to create questions");
    }
  };

  return (
    <div>
      <div className="row">
        <Header />
      </div>

      <div className="row">
        <div className="col-md-2 h-100 px-0">
          <Sidebar />
        </div>

        <div className="col-md-10 content-scroll content-bg px-3 py-3">
          <h4 className="mb-3">Create Multiple Questions</h4>

          <form onSubmit={handleSubmit}>
            {questions.map((formData, qIndex) => (
              <div className="card shadow mb-4" key={qIndex}>
                <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                  <span>Question {qIndex + 1}</span>

                  {questions.length > 1 && (
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      onClick={() => removeQuestion(qIndex)}
                    >
                      Remove Question
                    </button>
                  )}
                </div>

                <div className="card-body">
                  {/* Question */}
                  <div className="mb-3">
                    <label className="form-label">Question</label>
                    <textarea
                      className="form-control"
                      rows={3}
                      name="question"
                      value={formData.question}
                      onChange={(e) => handleChange(qIndex, e)}
                      required
                    />
                  </div>

                  {/* Options */}
                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="form-label mb-0">Options</label>

                      <button
                        type="button"
                        className="btn btn-sm btn-success"
                        onClick={() => addOption(qIndex)}
                      >
                        + Add Option
                      </button>
                    </div>

                    {formData.options.map((option, optIndex) => (
                      <div
                        key={optIndex}
                        className="d-flex align-items-center mb-2"
                      >
                        <input
                          type="text"
                          className="form-control"
                          placeholder={`Option ${optIndex + 1}`}
                          value={option}
                          onChange={(e) =>
                            handleOptionChange(qIndex, optIndex, e.target.value)
                          }
                          required
                        />

                        {formData.options.length > 2 && (
                          <button
                            type="button"
                            className="btn btn-danger ms-2"
                            onClick={() => removeOption(qIndex, optIndex)}
                          >
                            X
                          </button>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Correct Answer */}
                  <div className="mb-3">
                    <label className="form-label">Correct Answer</label>
                    <select
                      className="form-select"
                      name="correctAnswer"
                      value={formData.correctAnswer}
                      onChange={(e) => handleChange(qIndex, e)}
                      required
                    >
                      <option value="">Select Correct Answer</option>

                      {formData.options.map((option, index) => (
                        <option
                          key={index}
                          value={option}
                          disabled={!option.trim()}
                        >
                          {option.trim() || `Option ${index + 1}`}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Difficulty & Marks */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Difficulty</label>
                      <select
                        className="form-select"
                        name="difficulty"
                        value={formData.difficulty}
                        onChange={(e) => handleChange(qIndex, e)}
                      >
                        <option value="Easy">Easy</option>
                        <option value="Medium">Medium</option>
                        <option value="Hard">Hard</option>
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label">Marks</label>
                      <input
                        type="number"
                        className="form-control"
                        name="marks"
                        min={1}
                        value={formData.marks}
                        onChange={(e) => handleChange(qIndex, e)}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      College <span className="text-danger">*</span>
                    </label>

                    <select
                      className="form-select"
                      value={collegeId}
                      onChange={(e) => setCollegeId(e.target.value)}
                      required
                    >
                      <option value="">Select College</option>

                      {collegeList?.map((college: any) => (
                        <option key={college._id} value={college._id}>
                          {college.collegeName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            ))}

            <div className="d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={addQuestion}
              >
                + Add Another Question
              </button>

              <button type="submit" className="btn btn-success">
                Save All Questions
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateQuestions;
